export const GET_SESSION_DETAILS_REQUEST = 'GET_SESSION_DETAILS_REQUEST';
export const GET_SESSION_DETAILS_SUCCESS = 'GET_SESSION_DETAILS_SUCCESS';
export const GET_SESSION_DETAILS_FAILURE = 'GET_SESSION_DETAILS_FAILURE';
export const GET_SESSION_DETAILS_ATTENDEE_COUNT_REQUEST = 'GET_SESSION_DETAILS_ATTENDEE_COUNT_REQUEST';
export const GET_SESSION_DETAILS_ATTENDEE_COUNT_SUCCESS = 'GET_SESSION_DETAILS_ATTENDEE_COUNT_SUCCESS';
export const GET_SESSION_DETAILS_ATTENDEE_COUNT_FAILURE = 'GET_SESSION_DETAILS_ATTENDEE_COUNT_FAILURE';

export function getSessionDetails(sessionKey) {
  return {
    type: GET_SESSION_DETAILS_REQUEST,
    payload: { sessionKey }
  };
}



// WEBPACK FOOTER //
// ./src/Reducks/SessionDetails/SessionDetailsActions.js